import React from 'react'
import { useTranslation } from 'react-i18next'

import DrawerHeadline from '../../../../components/Drawer/DrawerHeadline'

import { ReactComponent as WarningIcon } from '../../../../assets/icons/warning-icon.svg'

import useStyles from './styles'
import useStepFormStyles from '../../../../styles/common/stepForms'
import useDrawerFormStyles from '../../../../styles/common/drawerForms'

const WarningMessage = ({ title, description }) => {
  const classes = useStyles()
  const stepFormClasses = useStepFormStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  return (
    <>
      {title && <DrawerHeadline title={t(title)} />}
      <div className={stepFormClasses.stepBody}>
        <div className={drawerFormClasses.section}>
          <div className={classes.warningIcon}>
            <WarningIcon />
          </div>
          {description && (
            <p className={classes.description}>{typeof description === 'string' ? t(description) : description}</p>
          )}
        </div>
      </div>
    </>
  )
}

export default WarningMessage
